'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.map')
require('core-js/modules/es.function.name')
require('core-js/modules/es.object.keys')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0

var _is = require('../is')

var _misc = require('../misc')

var _Val = _interopRequireDefault(require('./Val'))
exports.Val = _Val.default

function err(msg) {
  throw new Error(msg)
}

function checkTypeIsValid(type, val) {
  switch (type) {
    case 'string':
      return (0, _is.isStr)(val)
    case 'number':
      return (0, _is.isNum)(val)
    case 'boolean':
      return (0, _is.isBool)(val)
    case 'object':
      return (0, _is.isObj)(val)
    case 'array':
      return (0, _is.isArr)(val)
    case 'null':
      return (0, _is.isNull)(val)
    default:
      return false
  }
}

function isPrimitive(type) {
  return type !== 'object' && type !== 'array'
}

function getVal(value, valDefinitions) {
  var collected = valDefinitions._collect()
  var name = collected.name,
    type = collected.type,
    isRequired = collected.isRequired
  var typeIsValid = checkTypeIsValid(type, value)

  // debugger // eslint-disable-line no-debugger

  var val = value

  if (!typeIsValid) {
    if (collected.hasDefault) {
      val = collected.defaultVal
    } else if (collected.fillIfNot) {
      val = (0, _misc.cast)(val, type)
    } else if (isRequired) {
      err('value ' + name + ' is required, invalid and has no default or fill flag')
    }
  }

  if (isPrimitive(type)) {
    return val
  }
  if (type === 'array') {
    if (!(0, _is.isArr)(val) || !(collected.arrItem instanceof _Val.default)) return []
    var arrItemDef = collected.arrItem
    return val.map(function(arrItem) {
      return getVal(arrItem, arrItemDef)
    })
  }
  if (type === 'object') {
    if (collected.hasDefault) return collected.defaultVal
    if (!(0, _is.isObj)(val) || (0, _is.isArr)(val) || !(0, _is.isObj)(collected.props)) return {}
    var valAsObj = val
    var obj = {}
    var props = collected.props
    Object.keys(props).forEach(function(key) {
      obj[key] = getVal(valAsObj[key], props[key])
    })

    return obj
  }

  err('unhadeled case for value ' + name)
  return val
}

getVal.Val = _Val.default
var _default = getVal
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/getValidVal/index.js
// module id = 637
// module chunks = 0